"use client";

import {
  BUSINESS_FREQUENCIES,
  type BusinessFrequency,
  PRIVAT_FREQUENCIES,
  type PrivatFrequency,
} from "@/features/quote/shared/quote-config";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useWizard } from "@/features/quote/ui/wizard-context";
import { RadioCards } from "@/shared/ui/form/RadioCards";

export function FrequencyStep() {
  const { state, update, autoAdvance, goToStep, step, stepReady, isBusiness } = useWizard();

  return (
    <section>
      <StepHeading
        title="Hvor ofte?"
        body={
          isBusiness
            ? "Vælg den frekvens der passer bedst - det kan altid justeres senere."
            : "Vælg hvor tit du vil have rengøring - du kan altid justere det senere."
        }
      />
      <RadioCards
        options={
          (isBusiness ? BUSINESS_FREQUENCIES : PRIVAT_FREQUENCIES) as {
            value: PrivatFrequency | BusinessFrequency;
            label: string;
          }[]
        }
        value={state.frequency as PrivatFrequency | BusinessFrequency | ""}
        onChange={(v) => {
          update("frequency", v);
          autoAdvance();
        }}
        gridClassName={isBusiness ? "grid-cols-2 sm:grid-cols-3" : undefined}
      />
      <StepNav
        onBack={() => goToStep(step - 1)}
        onNext={() => goToStep(step + 1)}
        nextEnabled={stepReady("frequency")}
        nextLabel="Næste →"
      />
    </section>
  );
}
